import * as React from "react";

import cnccStrings, {images} from "./cncc-strings.ts";
import {withStrings} from "./locales/cncc-page/load-strings.tsx";
import Page from "./page.tsx";

const CNCCPage = (): React.ReactElement => (
    <Page strings={cnccStrings} images={images} />
);
export default withStrings(CNCCPage);
